import { render } from "./RowCategoriesForm.vue?vue&type=template&id=942ca61a&scoped=true"
import script from "./RowCategoriesForm.vue?vue&type=script&lang=js"
export * from "./RowCategoriesForm.vue?vue&type=script&lang=js"

import "./RowCategoriesForm.vue?vue&type=style&index=0&id=942ca61a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-942ca61a"]])

export default __exports__